var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.actionProcessing)?_c('div',{staticClass:"page_processing_modal"},[_c('div',{staticClass:"page_processing_card"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"loading image",attrs:{"src":require("@/assets/img/logos/favicon.png")}}),_c('p',[_vm._v("Please wait...")])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }